import React, { useState, useEffect } from 'react';
import './PWAUpdateNotification.css';

const PWAUpdateNotification = () => {
    const [showUpdate, setShowUpdate] = useState(false);
    const [waitingWorker, setWaitingWorker] = useState(null);

    useEffect(() => {
        // Listen for service worker updates
        if ('serviceWorker' in navigator) {
            navigator.serviceWorker.ready.then((registration) => {
                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing;

                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            // New service worker available
                            setWaitingWorker(registration.waiting);
                            setShowUpdate(true);
                        }
                    });
                });
            });
        }
    }, []);

    const handleUpdate = () => {
        if (waitingWorker) {
            waitingWorker.postMessage({ type: 'SKIP_WAITING' });
            waitingWorker.addEventListener('statechange', (e) => {
                if (e.target.state === 'activated') {
                    window.location.reload();
                }
            });
        }
        setShowUpdate(false);
    };

    const handleDismiss = () => {
        setShowUpdate(false);
    };

    if (!showUpdate) {
        return null;
    }

    return (
        <div className="pwa-update-notification">
            <div className="pwa-update-content">
                <div className="pwa-update-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="pwa-update-text">
                    <h4>Có phiên bản mới!</h4>
                    <p>Một bản cập nhật mới đã sẵn sàng. Vui lòng tải lại để sử dụng phiên bản mới nhất.</p>
                </div>
                <div className="pwa-update-actions">
                    <button className="pwa-btn pwa-btn-primary" onClick={handleUpdate}>
                        Cập nhật ngay
                    </button>
                    <button className="pwa-btn pwa-btn-secondary" onClick={handleDismiss}>
                        Để sau
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PWAUpdateNotification;
